import { V2SurveyRecommendationResource } from "@generated";
import { Survey } from "../types";
import { formatResource } from "../../Projects/ServicesV2/common";

type ApiTrigger = (arg: any) => { unwrap: () => Promise<any> };

// The generated v2 triggers the caller gets from its hooks.
export interface ApplySurveyApi {
  updateSurveyRecommendation: ApiTrigger;
  applySurveyRecommendations: ApiTrigger;
}

const applySurvey = async (
  recommendations: Survey["recommendations"],
  nonServiceRecommendations: Survey["recommendations"],
  surveyId: number,
  projectId: string,
  api: ApplySurveyApi,
  handleFailResponse: (msg: string) => void,
  fromProjectServices: boolean
) => {
  const appHost = process.env.REACT_APP_DOORKEEPER_APP_URL;

  if (!recommendations?.length && !nonServiceRecommendations?.length) {
    handleFailResponse("No recommendations to apply");
    return;
  }

  try {
    if (recommendations?.length) {
      for (const recommendation of recommendations) {
        if (recommendation.id) {
          const data: Partial<V2SurveyRecommendationResource> = {
            id: String(recommendation?.id),
            type: "survey-recommendations",
            attributes: {
              quantity: recommendation?.quantity,
              refinements: recommendation?.refinements?.map((r) => {
                return {
                  item_id: r.id,
                  quantity: Number(r.quantity ?? recommendation?.quantity ?? 1),
                  project_resource_id: r?.resource?.id
                    ? formatResource(r)?.data?.id
                    : recommendation?.resource?.id,
                };
              }),
            },
          };

          if (recommendation?.resource) {
            data.relationships = {
              "project-resource": formatResource(recommendation),
            };
          }

          // Update survey recommendations. A failed save rejects, which skips
          // the apply below and reports through the catch.
          await api
            .updateSurveyRecommendation({
              id: String(recommendation.id),
              body: { data },
            })
            .unwrap();
        } else return;
      }
    }

    //Apply survey
    await api.applySurveyRecommendations({ id: String(surveyId) }).unwrap();

    const path = fromProjectServices ? "project_editor" : "project_surveys";
    window.location.replace(`${appHost}/projects/${projectId}/${path}`);
  } catch (err) {
    handleFailResponse("");
  }
};

export default applySurvey;
